module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type == 'select') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.getValueSting,
      "autocomplete": "reset",
      "disabled": _vm.disabled,
      "clearable": _vm.clearable,
      "multiple": _vm.multiple,
      "collapse-tags": _vm.collapseTags,
      "filterable": "",
      "popper-append-to-body": false,
      "placeholder": _vm.placeholder || _vm.$t('system.select.common_select')
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.dictOptions), function(dict, index) {
    return _c('el-option', {
      key: _vm.code + index,
      attrs: {
        "disabled": _vm.disabledOptions(dict),
        "label": _vm.$languageChoose({
          zh: dict.text,
          en: dict.textEn,
        }),
        "title": _vm.$languageChoose({
          zh: dict.text,
          en: dict.textEn,
        }),
        "value": dict.value
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.type == 'radio') ? _c('div', [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.dictOptions), function(dict, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": dict.value
      }
    }, [_vm._v(_vm._s(_vm.$languageChoose({
      zh: dict.text,
      en: dict.textEn
    })) + "\n      ")])
  }), 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b69d82e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b69d82e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/libs/dictSelect/DictSelect.vue
// module id = 1573
// module chunks = 7